import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { roleOptionSelectors } from '../state/role-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: RoleSelectComponent,
        },
    ],
    selector: 'ndt-role-select',
    templateUrl: './role-select.component.html',
    standalone: false
})
export class RoleSelectComponent extends LcsSingleSelectBase<RoleOption> implements OnInit {
   roles: Observable<RoleOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.roles = this.store.pipe(select(roleOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: RoleOption | null): string | null {
      return item ? item.name : null;
   }

   trackBy(item: RoleOption | null) {
      return item ? item.roleId : null;
   }
}
